import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function TiktokDownloader() {
  useEffect(() => {
    document.title = 'TikTok Video Downloader — Download TikTok Videos Without Watermark';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Download TikTok videos without watermark in HD quality for free. Save any TikTok video as MP4 directly to your device.');

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: 'How to Download TikTok Videos Without Watermark',
      step: [
        { '@type': 'HowToStep', position: 1, text: 'Open TikTok, find the video, tap Share, and select "Copy Link".' },
        { '@type': 'HowToStep', position: 2, text: 'Paste the TikTok URL into HD Video Download.' },
        { '@type': 'HowToStep', position: 3, text: 'Click Download to save the video without watermark.' },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <div className="app">
      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>
        <h1 className="page-title">TikTok Video Downloader</h1>
        <p className="page-subtitle">Download TikTok videos without watermark in HD quality.</p>

        <div className="cta-section" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
          <Link to="/" className="cta-btn">Download TikTok Video Now</Link>
        </div>

        <h2 className="section-title">How to Download TikTok Videos</h2>
        <div className="steps">
          <div className="step"><span className="step-number">1</span><div><h3>Copy TikTok Link</h3><p>Open TikTok, find the video you want, tap the Share button, and select "Copy Link".</p></div></div>
          <div className="step"><span className="step-number">2</span><div><h3>Paste & Download</h3><p>Paste the TikTok URL into hdvideodownload.com and click "Download".</p></div></div>
          <div className="step"><span className="step-number">3</span><div><h3>Save Without Watermark</h3><p>Download the TikTok video as a clean MP4 file without the TikTok watermark.</p></div></div>
        </div>

        <h2 className="section-title">Why Use Our TikTok Downloader?</h2>
        <div className="seo-features">
          <div className="seo-feature"><h3>No Watermark</h3><p>Save TikTok videos without the TikTok logo watermark overlay.</p></div>
          <div className="seo-feature"><h3>HD Quality</h3><p>Download in the highest quality available — crisp and clear video.</p></div>
          <div className="seo-feature"><h3>No App Needed</h3><p>Works in any browser on iPhone, Android, PC, or Mac. No app installation required.</p></div>
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Download TikTok Videos Free</Link>
        </div>
      </div>
      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default TiktokDownloader;
